import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingApplicantAction = (body) => ({
  type : actions.UPDATE_PENDING_APPLICANT,
  payload : body
})

export const getSinglePendingApplicantAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_APPLICANT,
  payload: id
})

export const deleteSinglePendingApplicantAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_APPLICANT,
  payload: id
})

export const moderateCreateSinglePendingApplicantAction = (id,mode) => ({
  type: actions.MODERATE_SINGLE_PENDING_APPLICANT,
  payload: id,
  mode
})

// Plural
export const getPendingApplicantsAction = (body) => ({
  type: actions.GET_PENDING_APPLICANTS,
  payload: body,
});

/**
 * Actions that are fired by redux-saga watchers
*/

// Singular
export const updatePendingApplicantSuccessAction = (applicant) => ({
  type : actions.UPDATE_PENDING_APPLICANT_SUCCESS,
  payload : applicant
})

export const getSinglePendingApplicantSuccessAction = (applicant) => ({
  type: actions.GET_SINGLE_PENDING_APPLICANT_SUCCESS,
  payload: applicant
})


export const deleteSinglePendingApplicantSuccessAction = (id) => ({
  type:actions.DELETE_SINGLE_PENDING_APPLICANT_SUCCESS,
  payload: id
})

export const moderateCreateSinglePendingApplicantSuccessAction = (id) => ({
  type: actions.MODERATE_SINGLE_PENDING_APPLICANT_SUCCESS,
  payload: id
})

// Plural
export const getPendingApplicantsSuccessAction = (applicant) => ({
  type: actions.GET_PENDING_APPLICANTS_SUCCESS,
  payload: applicant,
});


/**
 * Misc
 */

export const setPendingApplicantsIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_APPLICANTS_IS_LOADING,
  payload: isLoading,
});

export const setPendingApplicantsCountAction = (count) => ({
  type: actions.SET_PENDING_APPLICANTS_COUNT,
  payload: count,
});
